import { NextSeo } from 'next-seo';
import TheTreatsPage from '../components/TheTreatsPage';

export default function MyKitties() {
  const title = 'Shitty Treats - Shitty Kitties';
  const description = `Collect treats for your each Shitty Kitty you own. You will be able to use these Shitty Treats for upcoming utilities.`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <TheTreatsPage />
    </div>
  );
}
